import {
  useMutation,
  useQueryClient,
  type QueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import type { ApiEnvelope } from '@/lib/task-api';
import { invalidateMarketplaceLists } from '@/lib/task-query-keys';
import { upsertOffer, type UpsertOfferInput } from './api';

/**
 * Teklif verme/guncelleme mutasyonu.
 *
 * TEKLIF LISTESI ile TALEP LISTESI birlikte gecersiz kilinir: yeni bir teklif
 * gorevin kartindaki "teklif ver" dugmesini "guncelle"ye cevirir; yalniz teklif
 * listesini tazelemek talebi bayat birakirdi.
 */
export const upsertOfferMutationOptions = (
  client: QueryClient,
): UseMutationOptions<ApiEnvelope, Error, UpsertOfferInput> => ({
  mutationFn: upsertOffer,
  onSuccess: () => {
    invalidateMarketplaceLists(client);
  },
});

export const useUpsertOffer = () => {
  const client = useQueryClient();
  return useMutation(upsertOfferMutationOptions(client));
};
